export default "__VITE_ASSET__BkB6bBhr__"